import React from 'react';
import CSSModules from 'react-css-modules';
import { compose, branch, renderNothing } from 'recompose';
import { injectIntl } from 'react-intl';

import styles from './index.styl';

export const SelectedSizeInfo = compose(
  injectIntl,
  branch(({ size }) => !size, renderNothing),
  CSSModules(styles, { allowMultiple: true }),
)(({ intl: { formatMessage }, textId, size }) => (
  <span styleName="label label--selected">
    {formatMessage(textId, {
      counter: size,
    })}
  </span>
));



// WEBPACK FOOTER //
// ./src/components/common/SearchDialog/SearchDialogImpl/SelectedSizeInfo.jsx